import { useMemo } from 'react';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { ContentfulRestLink } from './links';
import possibleTypes from '../../types/possibleTypes.json';
let apolloClient;

const createApolloClient = options => {
  const {
    space,
    accessToken,
    environment,
    previewAccessToken
  } = Object.assign({}, {
    space: process.env.CONTENTFUL_SPACE_ID || '',
    accessToken: process.env.CONTENTFUL_ACCESS_TOKEN_DELIVERY || '',
    previewAccessToken: process.env.CONTENTFUL_ACCESS_TOKEN_PREVIEW,
    environment: process.env.CONTENTFUL_ENVIRONMENT
  }, options);
  return new ApolloClient({
    link: new ContentfulRestLink({
      space,
      environment,
      accessToken,
      previewAccessToken
    }, {
      include: 10
    }),
    ssrMode: typeof window === 'undefined',
    cache: new InMemoryCache({
      possibleTypes
    })
  });
};

export const initializeApollo = ({
  initialState,
  options
} = {}) => {
  var _apolloClient2;

  const _apolloClient = (_apolloClient2 = apolloClient) !== null && _apolloClient2 !== void 0 ? _apolloClient2 : createApolloClient(options); // If your page has Next.js data fetching methods that use Apollo Client, the initial state
  // gets hydrated here


  if (initialState) {
    // Get existing cache, loaded during client side data fetching
    const existingCache = _apolloClient.extract(); // Restore the cache using the data passed from getStaticProps/getServerSideProps
    // combined with the existing cached data


    _apolloClient.cache.restore({ ...existingCache,
      ...initialState
    });
  } // For SSG and SSR always create a new Apollo Client


  if (typeof window === 'undefined') return _apolloClient; // Create the Apollo Client once in the client

  if (!apolloClient) apolloClient = _apolloClient;
  return _apolloClient;
};
export const useApollo = (initialState, options) => {
  const store = useMemo(() => initializeApollo({
    initialState,
    options
  }), [initialState, options]);
  return store;
};